//@ts-nocheck
import React from 'react'
import { cbModal } from '../../../../../../../index'
import { useSlateStatic } from 'slate-react'
import ImageModal from './Modal/ModalComponent'
import UploadModal from './Modal/UploadModal'
import { isEmbedAssetLinkActive } from '../utils'

/**
 * Opens the asset selection modal for choosing images from the asset library.
 * This function is used in JsonRTE's "Choose from assets" option in the Image dropdown.
 * 
 * @param {Event} e - The mouse/keyboard event
 * @param {Editor} editor - The Slate editor instance
 * @param {string} type - The type of asset being selected (e.g., 'image', 'asset')
 */
const openChooseFromImageModal = (e, editor, type) => {
  e.preventDefault()
  editor.setFullScreen();
  
  const CustomModal = type === "assetLink" ? editor.customEmbedAssetsModal : editor.customChooseFromAssetsModal
  
  // Validate that CustomModal is a valid React component (function component or class component)
  if (CustomModal && (typeof CustomModal === 'function' || typeof CustomModal === 'object')) {
    // Render the custom modal provided by the consumer
    cbModal({
      component: (modalProps) => <CustomModal editor={editor} type={type} {...modalProps} />,
      modalProps: {
        size: 'max',
        customClass: 'reference__modal scrte-reference__modal',
        shouldReturnFocusAfterClose: false
      },
    })
  } else {
    // Fallback to the default ImageModal component for asset selection
    cbModal({
      component: (props) => <ImageModal editor={editor} type={type} {...props} />,
      modalProps: {
        size: 'max',
        customClass: 'reference__modal scrte-reference__modal',
        shouldReturnFocusAfterClose: false
      },
    })
  }
}

export const ImageOverlay = (props) => {
  const editor = useSlateStatic()

  /**
   * Handles mouse click events on the image overlay button.
   * Determines which modal to display based on type and available configurations.
   * 
   * Priority order:
   * 1. Custom modal (type-dependent: customEmbedAssetsModal or customChooseFromAssetsModal) - Consumer-provided modal component
   * 2. V2 Embed Picker (editor.showAssetEmbedModal) - New embed picker interface
   * 3. Default modal - Built-in ImageModal component
   */
  const handleMouseDown = (e, { editor }) => {
    const type = props.type
    const CustomModal = type === "assetLink" ? editor.customEmbedAssetsModal : editor.customChooseFromAssetsModal
    
    // Priority 1: Use consumer-provided custom modal if available (type-dependent)
    if (CustomModal && (typeof CustomModal === 'function' || typeof CustomModal === 'object')) {
      e.preventDefault()
      editor.setFullScreen()
      return cbModal({
        component: (modalProps) => <CustomModal editor={editor} type={type} {...modalProps} />,
        modalProps: {
          size: 'max',
          customClass: 'reference__modal scrte-reference__modal',
          shouldReturnFocusAfterClose: false
        },
      })
    }
    
    // Priority 2: Use V2 embed picker if feature flag is enabled and modal handler exists
    if(editor.useV2EmbedPicker && editor.showAssetEmbedModal){
      return editor.showAssetEmbedModal({...props})
    }
    
    // Priority 3: Fallback to default asset selection modal
    openChooseFromImageModal(e, editor, props.type)
  }

  return (
    <React.Fragment>
      {props.children({
        handleMouseDown: handleMouseDown,
        active: props.type === 'link' && isEmbedAssetLinkActive(editor),
        additionalParams: { editor },
      })}
    </React.Fragment>
  )
}

export const shortcutOpenChooseFromImageModal = (event, editor, format, registryObj, type?) => {
  openChooseFromImageModal(event, editor, type)
}

export const UploadOverlay = (props) => {
  const editor = useSlateStatic();

  const handleMouseDown = (e, { editor }) => {
    e.preventDefault()
    editor.setFullScreen();
    if (typeof editor.openAMV2UploadTarget === 'function') {
      editor.openAMV2UploadTarget(editor)
      return
    }
    cbModal({
      component: (props) => <UploadModal editor={editor} {...props} type='asset' />,
      modalProps: {
        size: 'max',
        shouldReturnFocusAfterClose: false,
        customClass: 'reference__modal scrte-reference__modal',
      },
    })
  }

  return (
    <React.Fragment>
      {props.children({
        handleMouseDown: handleMouseDown,
        additionalParams: { editor },
      })}
    </React.Fragment>
  )
}
        